/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Fragment } from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import { Typography } from '@material-ui/core';
import {
  checkSubqchoices,
  getDCText,
  getGoalSummary,
  getReadText,
  getCPPReadOnlyInputText,
  hasNodeValue,
  isSubqchoice,
  isSubqchoiceNotNull,
  updateStructure,
  checkGoalType,
  doNotDisplayText,
} from '@mummssoftware/utils/form-engine/form-engine-utils';
import { renderTaggedNotes } from '@mummssoftware/common-ui';
import {
  FormBody,
  StyledLi,
  StyledReadOnlyUl,
  DCDiv,
  FormLi,
  StyledDiv,
  InputDiv,
  NoCPPText,
  DCSegment,
} from './WrapperDiv';
import { useStyles } from './style';
import { ReadLabelField } from './Field';
import {
  horizontal,
  label,
  input,
  singleselect,
  multiselect,
  goals,
} from './constants';
import defaults from '../../translations/en.json';
import { data } from './data/physicalComfortPain';
type ReadOnlyFormProps = {
  // we are passing the formsubmission of the API get CPP by id
  formData: string | any;
  title?: string | null;
  printView?: boolean;
  pnNotes?: null | any[];
  dialogHeight?: boolean;
  previewData?: boolean;
};

/**
 * Read Only Form only gets the answered data that need to be displayed
 * Most element types are transformed into <li> => checkboxes, radio button ...
 */
export const ReadOnlyForm = ({
  formData,
  pnNotes,
  title,
  printView,
  dialogHeight,
  previewData,
}: ReadOnlyFormProps) => {
  const classes = useStyles();

  let parsedData: any;

  // Read Only Form API call comes back as a string VS Preview Form array type
  if (typeof formData === 'string') {
    try {
      parsedData = formData && JSON.parse(formData);
    } catch (e) {
      // catch JSON parse exceptions
      // TODO alert
      console.log('JSON PARSING ERROR', e);
    }
  } else {
    // Preview Form array type
    parsedData = formData;
  }
  const updateddata =
    parsedData && parsedData[0] ? updateStructure(parsedData) : undefined;
  const updatedData = updateddata && updateddata[0] ? updateddata : undefined;
  // console.log('***ReadOnlyForm updatedData***', updatedData);

  // @note empty Read Only are updatedData = [null]

  const getDCSegment = (subqchoice: any) => (
    <DCSegment>{getDCText(subqchoice)}</DCSegment>
  );

  const renderField = (
    subqchoice: any,
    subMenu: any,
    // eslint-disable-next-line consistent-return
  ) => {
    switch (subqchoice.controltype) {
      case label:
        return (
          <div
            key={`label-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-label"
          >
            <FormLi
              key={`li-${subqchoice.id}-${subqchoice.questionpath}`}
              horizontal={subqchoice.drawmode === horizontal}
            >
              <ReadLabelField
                key={`field-${subqchoice.id}-${subqchoice.questionpath}`}
                text={getReadText(subqchoice)}
                isExpanded={isSubqchoice(subqchoice)}
              />
              {subMenu}
            </FormLi>
          </div>
        );
      case input:
        // @note subqchoice.isothercomment => to not get input component 2 times with the one from Other dropdown
        return subqchoice.isothercomment ? null : (
          <InputDiv
            key={`input-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-input"
          >
            <StyledDiv key={`li-${subqchoice.id}-${subqchoice.questionpath}`}>
              {doNotDisplayText(subqchoice)
                ? ''
                : getCPPReadOnlyInputText(subqchoice)}
              {subMenu}
            </StyledDiv>
          </InputDiv>
        );
      case singleselect:
      case multiselect: {
        return subqchoice.overwritedrawmode ? (
          <div
            key={`checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}`}
            id="read-only-select"
          >
            <StyledLi key={`li-${subqchoice.id}-${subqchoice.questionpath}`}>
              {isSubqchoice(subqchoice) && getReadText(subqchoice)}
              {subMenu}
            </StyledLi>
          </div>
        ) : (
          <div
            key={`checkbox-${subqchoice.parentquestionpath}-${subqchoice.id}-${subqchoice.questionpath}`}
            id="read-only-select"
          >
            <StyledDiv
              key={`li-${subqchoice.id}-${subqchoice.questionpath}`}
              horizontal={subqchoice.drawmode === horizontal}
            >
              {isSubqchoice(subqchoice) && getReadText(subqchoice)}
              {subMenu}
            </StyledDiv>
          </div>
        );
      }
      case goals: {
        return (
          <div
            key={`checkbox-${subqchoice.dc_id}-${subqchoice.id}-${subqchoice.legacyformid}`}
            id="read-only-goals"
          >
            <StyledLi
              key={`li-${subqchoice.id}-${subqchoice.legacyformid}`}
              dc={!!subqchoice.dcdate}
            >
              {subqchoice.dcdate ? (
                <DCDiv id="dc-item">
                  {getGoalSummary(subqchoice)}
                  {getDCSegment(subqchoice)}
                </DCDiv>
              ) : (
                getGoalSummary(subqchoice)
              )}
              {subMenu}
            </StyledLi>
          </div>
        );
      }
      // case checkbox, radio and null:
      default: {
        // dc items are checkboxes
        const noLabel = subqchoice.dcdate;
        return (
          <div
            key={`checkbox-${subqchoice.questionpath}-id-${subqchoice.id}-path-${subqchoice.dcdate}`}
            id="read-only-default"
          >
            <StyledLi
              key={`li-${subqchoice.id}-${subqchoice.questionpath}`}
              dc={!!subqchoice.dcdate}
              horizontal={subqchoice.drawmode === horizontal}
            >
              <>
                {!noLabel && (
                  <>{isSubqchoice(subqchoice) && getReadText(subqchoice)}</>
                )}
                {subqchoice.dcdate && (
                  <DCDiv id="dc-item">
                    <div>{getReadText(subqchoice)}</div>
                    {getDCSegment(subqchoice)}
                  </DCDiv>
                )}
              </>

              {subMenu}
            </StyledLi>
          </div>
        );
      }
    }
  };

  const renderSubMenu = (
    subqchoices: any,
    depthLevel = 0,
    isHorizontal?: boolean,
  ) => {
    const menuOptions = subqchoices.map((subqchoice: any) => {
      if (checkGoalType(subqchoice)) {
        subqchoice.controltype = goals;
      }

      const hasOptions =
        checkSubqchoices(subqchoice) && !checkGoalType(subqchoice);

      let subMenu;
      const hasValue = depthLevel === 0 ? true : isSubqchoice(subqchoice);
      const isHorizontalMode = subqchoice.drawmode === horizontal;

      // only render selected submenu and only if nested options exist

      if (hasValue && hasOptions) {
        const newDepthLevel = depthLevel + 1;

        const subChoices = subqchoice.subqchoices.filter(
          (choice: any) => choice.dcdate || isSubqchoiceNotNull(choice),
        );

        subMenu = renderSubMenu(subChoices, newDepthLevel, isHorizontalMode);
      }

      // if READ ONLY MODE : only display the field with value or if it has been DC
      // if PREVIEW MODE : only display the field with value
      const hasChoiceValue = previewData
        ? hasNodeValue(subqchoice)
        : hasNodeValue(subqchoice) || subqchoice.dcdate;

      return hasChoiceValue && renderField(subqchoice, subMenu);
    });

    // TO KNOW The <ul> tag has a default padding-inline-start of 40px

    return (
      <div key={`div-key-${depthLevel}`}>
        <FormGroup>
          <StyledReadOnlyUl id="read-only-ul" horizontal={isHorizontal}>
            {menuOptions}
          </StyledReadOnlyUl>
        </FormGroup>
      </div>
    );
  };

  return (
    <FormBody id="read-only" printView={printView} dialogHeight={dialogHeight}>
      {title && (
        <Typography
          variant="body1"
          classes={
            printView
              ? {
                  root: classes.printTitle,
                }
              : {}
          }
        >
          {title}
        </Typography>
      )}
      <Fragment>
        {updatedData && updatedData[0] && renderSubMenu(updatedData)}
        {!updatedData && <NoCPPText>{defaults.noCPP}</NoCPPText>}
      </Fragment>
      <Fragment>
        {pnNotes && renderTaggedNotes(pnNotes, defaults.relatedNotes)}
      </Fragment>
    </FormBody>
  );
};

export default ReadOnlyForm;
